module.exports = __webpack_public_path__ + "img/main.c712594f.png";